import { Star } from "lucide-react";

const reviews = [
  {
    name: "Thomas M.",
    text: "BEKAJ BAU hat unsere Wohnung komplett renoviert. Saubere Arbeit, pünktliche Umsetzung und super Kommunikation. Absolut empfehlenswert!",
    rating: 5
  },
  {
    name: "Sandra K.",
    text: "Professionelle Fassadenarbeiten zu einem fairen Preis. Das Team war freundlich und hat alles termingerecht fertiggestellt. Wir sind begeistert!",
    rating: 5
  },
  {
    name: "Michael B.",
    text: "Herr Bekaj und sein Team haben unseren Trockenbau perfekt umgesetzt. Von der Beratung bis zur Abnahme alles top. Klare 5 Sterne!",
    rating: 5
  },
  {
    name: "Petra W.",
    text: "Wir haben BEKAJ BAU für unsere Badsanierung beauftragt. Das Ergebnis hat unsere Erwartungen übertroffen. Sehr sauberes Arbeiten!",
    rating: 5
  },
  {
    name: "Andreas H.",
    text: "Schnelle Rückmeldung, direkte Kommunikation per WhatsApp und ein hervorragendes Ergebnis. So muss Handwerk sein!",
    rating: 5
  },
  {
    name: "Julia R.",
    text: "Kompletter Innenausbau in Rekordzeit. Die Qualität stimmt, der Preis ist fair. Wir empfehlen BEKAJ BAU uneingeschränkt weiter.",
    rating: 5
  }
];

const StarRating = () => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-[#FBBC04] text-[#FBBC04]" />
    ))}
  </div>
);

const Reviews = ({ content }) => {
  const reviewData = content?.reviews || {};
  const headline = reviewData.headline || "Was Kunden über BEKAJ BAU sagen";
  const subheadline = reviewData.subheadline || "26 echte 5-Sterne-Bewertungen sprechen für sich.";
  const rating = reviewData.rating || 5.0;
  const count = reviewData.count || 26;
  const activeReviews = reviewData.items
    ? reviewData.items.filter(r => r.active !== false)
    : reviews;

  return (
    <section className="py-16 sm:py-20 bg-white" data-testid="reviews-section" id="bewertungen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-14">
          <h2
            className="text-3xl sm:text-4xl font-bold text-[#4A331D] mb-3"
            style={{ fontFamily: "Work Sans, sans-serif" }}
          >
            {headline}
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            {subheadline}
          </p>
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-[#FBBC04] text-[#FBBC04]" />
              ))}
            </div>
            <span className="text-lg font-bold text-[#4A331D]">{rating}</span>
            <span className="text-gray-500 text-sm">auf Google</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {activeReviews.map((review, idx) => (
            <div
              key={idx}
              className="bg-[#faf8f5] border border-[#e8dfd4] rounded-xl p-6 hover:shadow-md transition-shadow"
              data-testid={`review-card-${idx}`}
            >
              <StarRating />
              <p className="text-gray-700 mt-3 mb-4 text-sm leading-relaxed">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-[#4A331D] flex items-center justify-center text-white font-bold text-sm">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-[#4A331D] text-sm">{review.name}</p>
                  <div className="flex items-center gap-1">
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                    </svg>
                    <span className="text-xs text-gray-500">Google</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
